import React from 'react';
import Goals from './Goals';

const GoalsPage = () => {
  return (
    <div className="goals-page">
      <h1>Fitness Goals</h1>
      <p className="page-description">
        Set, track and achieve your fitness goals. Create specific, measurable goals and monitor your progress over time.
      </p>
      
      <Goals />
    </div>
  );
};

export default GoalsPage;
